export const rolesList = [
  { value: "admin", label: "Admin" },
  { value: "authorized_user", label: "Usuario" },
];
